import _taggedTemplateLiteral from '../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled } from '@mgmresorts/wcl-styled';
import { display, width, minWidth, maxWidth, height, minHeight, maxHeight, flex, order, alignSelf, textAlign, lineHeight, letterSpacing } from '../../../../node_modules/styled-system/dist/index.esm.es.js';
import { space } from '../../../../node_modules/@styled-system/space/dist/index.esm.es.js';
import { color } from '../../../../node_modules/@styled-system/color/dist/index.esm.es.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var Text = styled.div(display, space, width, minWidth, maxWidth, height, minHeight, maxHeight, color, flex, order, alignSelf, textAlign, lineHeight, letterSpacing);
var Heading45 = styled(Text)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 45px;\n  font-weight: 500;\n"])));
Heading45.defaultProps = {
  color: '#000',
  lineHeight: '1.07',
  letterSpacing: '-0.3px'
};
var Heading40 = styled(Text)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 40px;\n  font-weight: 500;\n"])));
Heading40.defaultProps = {
  color: '#000',
  lineHeight: 1,
  letterSpacing: '-1px'
};
var Heading35 = styled(Text)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 35px;\n  font-weight: 500;\n"])));
Heading35.defaultProps = {
  color: '#000',
  lineHeight: '1.14',
  letterSpacing: 'normal'
};
var Heading28 = styled(Text)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 28px;\n  font-weight: 500;\n"])));
Heading28.defaultProps = {
  color: '#000',
  lineHeight: '1.25',
  letterSpacing: 'normal'
};
var Heading16 = styled(Text)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: 500;\n"])));
Heading16.defaultProps = {
  color: '#000',
  lineHeight: '1.2',
  letterSpacing: 'normal'
};
var Heading20 = styled(Text)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 20px;\n  font-weight: 500;\n"])));
Heading20.defaultProps = {
  color: '#000',
  lineHeight: '1.2',
  letterSpacing: 'normal'
};
var Text14 = styled(Text)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 500;\n"])));
Text14.defaultProps = {
  color: '#000',
  lineHeight: '1.5',
  letterSpacing: 'normal'
};
var Text16 = styled(Text)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: 500;\n"])));
Text16.defaultProps = {
  color: '#000',
  lineHeight: '1.33',
  letterSpacing: 'normal'
};
var Text12 = styled(Text)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 500;\n"])));
Text12.defaultProps = {
  color: '#000',
  lineHeight: '1.67',
  letterSpacing: 'normal'
};
var Text10 = styled(Text)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-size: 10px;\n  font-weight: 500;\n"])));
Text10.defaultProps = {
  color: '#000',
  lineHeight: '2',
  letterSpacing: 'normal'
};

export { Heading16, Heading20, Heading28, Heading35, Heading40, Heading45, Text, Text10, Text12, Text14, Text16 };
